module.exports = __webpack_public_path__ + "media/images/info_box_white-2dc94084e14f91b107461314c2474ce2.svg";